import React from 'react';
import ActionModal from 'components/common/modals/ActionModal';
import { useRootStore } from 'store/rootStore';
import { ModalType } from 'global/utils/ModalsHelper';
import { observer } from 'mobx-react-lite';
import { toJS } from 'mobx';
import { Table, TableRow, TableBody, TableCell } from '@insurancemenu/imenu-components-lib';
import JSONPretty from 'react-json-pretty';
import uniqid from 'uniqid';
import { createStyles } from './styles';
import 'react-json-pretty/themes/acai.css';

const EmailContextModal = observer((): JSX.Element => {
  const classes = createStyles();
  const {
    emailsDashboardStore: { isModalOpen, selectedSendGridContext, selectedEmail, modalLoading, closeModal },
  } = useRootStore();

  const convertedEmailContext = toJS(selectedSendGridContext);
  const convertedSelectedEmail = toJS(selectedEmail);

  const modalContent = (
    <div className={classes.modalContent}>
      <div className={classes.infoTableWrapper}>
        <Table totalElements={convertedSelectedEmail?.reason ? 4 : 3} minHeight="auto">
          <TableBody className={classes.tableBody}>
            <TableRow className={classes.tableRow}>
              <TableCell className={classes.tableCell}>Template Id</TableCell>
              <TableCell className={classes.tableCell}>{selectedSendGridContext?.templateId}</TableCell>
            </TableRow>
            <TableRow className={classes.tableRow}>
              <TableCell className={classes.tableCell}>From email</TableCell>
              <TableCell className={classes.tableCell}>{selectedSendGridContext?.from}</TableCell>
            </TableRow>
            <TableRow className={classes.tableRow}>
              <TableCell className={classes.tableCell}>To emails</TableCell>
              <TableCell className={classes.tableCell}>
                {selectedSendGridContext?.toEmailAddresses.map((email, index) => {
                  return (
                    <React.Fragment key={uniqid()}>
                      <span>{email}</span>
                      {index + 1 !== selectedSendGridContext?.toEmailAddresses.length && <br />}
                    </React.Fragment>
                  );
                })}
              </TableCell>
            </TableRow>
            {convertedSelectedEmail?.reason ? (
              <TableRow className={classes.tableRow}>
                <TableCell className={classes.tableCell}>Failed reason</TableCell>
                <TableCell className={classes.tableCell}>{convertedSelectedEmail?.reason}</TableCell>
              </TableRow>
            ) : (
              <></>
            )}
          </TableBody>
        </Table>
      </div>
      <h3 className={classes.contextTitle}>Send Grid Context</h3>
      <div className={classes.sendGridContext}>
        <JSONPretty
          id="sendGridContext"
          data={convertedEmailContext?.templateData}
          style={{ fontSize: '1.8rem' }}
          mainStyle="padding:1rem"
        />
      </div>
    </div>
  );

  return (
    <div>
      <ActionModal
        show={isModalOpen}
        title="Email Context"
        subtitle="Email Info with SendGrid context"
        closeButtonText="Close"
        onClose={closeModal}
        modalContent={modalContent}
        modalType={ModalType.NO_ICON}
        loading={modalLoading}
      />
    </div>
  );
});

export default EmailContextModal;
